import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import {
  VARIANT_MODAL_CONTENT_PADDING,
  VARIANT_MODAL_MODE,
  VARIANT_MODAL_WIDTH,
} from '../constants';
import RecipeVariantModal from '../index';

const MODE_META = {
  [VARIANT_MODAL_MODE.CREATE]: {
    icon: '/images/inpulse/add-black-small.svg',
    titleKey: 'ADMIN.RECIPES.VARIANT_MODAL.CREATE_TITLE',
    introKey: 'ADMIN.RECIPES.VARIANT_MODAL.CREATE_INTRO',
  },
  [VARIANT_MODAL_MODE.EDIT]: {
    icon: '/images/inpulse/edit-pen-black-small.svg',
    titleKey: 'ADMIN.RECIPES.VARIANT_MODAL.EDIT_TITLE',
    introKey: 'ADMIN.RECIPES.VARIANT_MODAL.EDIT_INTRO',
  },
  [VARIANT_MODAL_MODE.MAIN_RECIPE]: {
    icon: '/images/inpulse/edit-pen-black-small.svg',
    titleKey: 'ADMIN.RECIPES.VARIANT_MODAL.MAIN_RECIPE_TITLE',
    introKey: 'ADMIN.RECIPES.VARIANT_MODAL.MAIN_RECIPE_INTRO',
  },
};

export const getRecipeVariantModalConfig = ({
  mode,
  variantName,
  setVariantName,
  isVariantNameLocked,
  nameErrorMessage,
  groups,
  selectedGroups,
  setSelectedGroups,
  stores,
  selectedStores,
  setSelectedStores,
  handleSave,
  handleCloseCleanUp,
}) => {
  const modeMeta = MODE_META[mode];

  return {
    type: 'action',
    width: VARIANT_MODAL_WIDTH,
    height: 'auto',
    icon: modeMeta.icon,
    title: i18next.t(modeMeta.titleKey),
    customPadding: VARIANT_MODAL_CONTENT_PADDING,
    applyOverflow: false,
    isLoading: false,
    handleCloseCleanUp,
    component: RecipeVariantModal,
    data: {
      introTranslationKey: modeMeta.introKey,
      hideVariantNameInput: mode === VARIANT_MODAL_MODE.MAIN_RECIPE,
      variantName,
      setVariantName,
      isVariantNameLocked,
      nameErrorMessage,
      groups,
      selectedGroups,
      setSelectedGroups,
      stores,
      selectedStores,
      setSelectedStores,
    },
    actions: [
      GENERIC_MODAL_CANCEL_BUTTON(),
      {
        ...GENERIC_MODAL_SAVE_BUTTON(),
        isDisabled: !variantName?.trim() || !!nameErrorMessage,
        preventClosing: true,
        handleClick: handleSave,
      },
    ],
  };
};
